import { render, staticRenderFns } from "./innovative-footer.vue?vue&type=template&id=8fe82b76&"
import script from "./innovative-footer.vue?vue&type=script&lang=js&"
export * from "./innovative-footer.vue?vue&type=script&lang=js&"
import style0 from "./innovative-footer.vue?vue&type=style&index=0&id=8fe82b76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports